"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _Question = require("../Question");

var _Question2 = _interopRequireDefault(_Question);

var _TextArea = require("../TextArea");

var _TextArea2 = _interopRequireDefault(_TextArea);

var _common = require("modules/common");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _components2 = require("egov-ui-kit/components");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Question } from "modules/common";
// import { TextArea } from "modules/common";
var ReopenComplaintForm = function ReopenComplaintForm(_ref) {
  var form = _ref.form,
      formKey = _ref.formKey,
      options = _ref.options,
      ontextAreaChange = _ref.ontextAreaChange,
      handleOptionChange = _ref.handleOptionChange,
      optionSelected = _ref.optionSelected,
      commentValue = _ref.commentValue,
      role = _ref.role,
      onSubmit = _ref.onSubmit;

  var fields = form.fields || {};
  var submit = form.submit;
  // let handleChangeOptions = (e, value) => {
  //   handleOptionChange(e, value);
  // };
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: "form-without-button-cont-generic" },
      role && role !== "csr" && _react2.default.createElement(
        "div",
        { className: "reopencomplaint-upload-photo" },
        _react2.default.createElement(_common.ImageUpload, { module: "rainmaker-pgr", formKey: formKey, fieldKey: "media" })
      ),
      _react2.default.createElement(
        "div",
        { className: "reopencomplaint-question" },
        _react2.default.createElement(
          _core.Grid,
          null,
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 12 },
            _react2.default.createElement(_components2.AutoSuggestDropdown, {
              className: "fix-for-layout-break bg-transparent",
              style: { width: "100%" },
              dataSource: options,
              required: "true"
              // onChange={(e, value) => {
              //   handleChangeOptions(e, value);
              // }}
              , onChange: handleOptionChange,
              valueSelected: optionSelected,
              floatingLabelText: "Reopen Reason",
              hintText: "Select Reason"
              // {...wardData}
            })
          )
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "reopencomplaint-textArea position-relative mb-5" },
        _react2.default.createElement(_translationNode2.default, {
          key: 0
          // label="EVENTS_START_DATE_LABEL"
          , className: "comment_container",
          label: "Comments",
          color: "rgba(0,0,0,0.60)",
          fontSize: "12px"
        }),
        _react2.default.createElement(_TextArea2.default, (0, _extends3.default)({ onChange: ontextAreaChange, value: commentValue }, fields.textarea))
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "responsive-action-button-cont" },
      _react2.default.createElement(_components.Button, (0, _extends3.default)({ className: "responsive-action-button" }, submit, { onClick: onSubmit, primary: true, fullWidth: true }))
    )
  );
};

exports.default = ReopenComplaintForm;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/pgr/ReOpenComplaint/components/ReopenComplaintForm/index.js
// module id = 3388
// module chunks = 1137